import { cn } from '@/shared/lib/utils';

type CardProps = {
  variant?: 'default' | 'accent';
} & React.ComponentPropsWithRef<'div'>;

export const Card = ({ className, ref, variant = 'default', ...props }: CardProps) => {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg border border-border-base bg-surface-base p-6 shadow-sm',
        variant === 'accent' && 'border-border-success bg-surface-accent',
        className,
      )}
      {...props}
    />
  );
};
